module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"finished":"練習終了","message":"練習はここまでです。<br />\\nお疲れさまでした！ \\n","redo":"練習をやり直す","go_ahead":"本番へ進む"},"en":{"finished":"Practice Completed!","message":"Well Done!","redo":"Repeat Practice","go_ahead":"Continue to Real Classification"}}')
  delete Component.options._Ctor
}
